module.exports = __webpack_public_path__ + "img/abilities.7fce5a54.svg";